<template>
  <div id="app">
    <app-header class="app-header"></app-header>
    <div>
      <keep-alive>
        <router-view v-if="isKeepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!isKeepAlive"></router-view>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
export default {
  name: 'App',
  data() {
    return {
      isKeepAlive: false
    }
  },
  mounted() {

  },
  watch: {
    $route(to, form) {
      this.isKeepAlive = this.$route.meta.isKeepAlive
    }
  },
  components: {
    AppHeader
  }
}
</script>

<style lang="scss">
 @import '@/assets/scss/common.scss';
html, body {
  height: 100%;
}
body{
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
#app {
  min-height: 100%;
  background: #EFF3FB;
  .app-header{
    position: relative;
    left: 0;
    top: 0;
    z-index: 2000;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue